import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useInfrastructureChartsDataContext } from './hooks/useInfrastructureChartsDataContext';

export const PavementType = () => {
    const { chartData } = useInfrastructureChartsDataContext();


    return (
        <SimpleBars
            title={'Piso Predominante'}
            horizontal={true}
            subtitles={chartData?.pavementType?.map((item) => item.description)}
            values={chartData?.pavementType?.map((item) => item.total  ||  0)}
        />
    );
};
